export default __webpack_public_path__ + "static/media/AlienCh7.fdf00279.svg";